function Attendance(data) {
  this.comment            = data.comment;
  this.created_at         = data.created_at;
  this.employee_server_id = data.employee_server_id;
  this.event_type         = data.event_type;
  this.id                 = data.id;
  this.is_modified        = data.is_modified;
  this.tag                = data.tag;
  this.latitude           = ('latitude'  in data) ? data.latitude  : null;
  this.longitude          = ('longitude' in data) ? data.longitude : null;
  this.is_automatic       = data.is_automatic;
  if (this.comment === '') this.comment = null;
}

Attendance.prototype = {
  constructor: Attendance,
  hasLocation: function() {
    return this.latitude !== null && this.longitude !== null;
  },
  getData: function() {
    return {
      comment:            this.comment,
      created_at:         this.created_at,
      employee_server_id: this.employee_server_id,
      event_type:         this.event_type,
      id:                 this.id,
      is_modified:        this.is_modified,
      tag:                this.tag,
      latitude:           this.latitude,
      longitude:          this.longitude,
      is_automatic:       this.is_automatic,
    }
  }
};

Attendance.processArray = function(arr) {
    for (var k in arr) arr[k] = new Attendance(arr[k]);
    return arr;
};

export default Attendance;
